import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import sanityClient from "../client.js";
import BlockContent from "@sanity/block-content-to-react";
import imageUrlBuilder from "@sanity/image-url";
import styled from "styled-components";
import ReactPlayer from "react-player";
import logo from '../assets/logo@2x.png';

// const { clamp } = require('../assets/methods.js');

const builder = imageUrlBuilder(sanityClient);
function urlFor(source) {
    return builder.image(source);
}

const Post = (props) => {
    const [postData, setPostData] = useState(null);
    // const [imgSrc, setImgSrc] = useState("");

    // props passed through URL params & location.state
    const { slug } = useParams();
    // const { nextIndex } = props.location.state;
    // const { prevIndex } = props.location.state;

    // // calculate next and previous indices for PostSwitcher
    // const nextIndex = index + 1;
    // const prevIndex = index - 1;


    useEffect(() => {
        sanityClient
            .fetch(
                `*[slug.current == $slug]{
                title,
                author,
                slug,
                videoUrl,
                publishedAt,
                mainImage{
                    asset->{
                        _id,
                        url
                    }
                },
                body
            }`,
                { slug }
            )
            .then((data) => setPostData(data[0]))
            .catch(console.error);
    }, [slug]);

    if (!postData) return <div>Loading...</div>;

    return (
        <PostContainer>
            <Header>
                <Link className="logo" to="/">
                    <img src={logo} alt="logo" />
                </Link>
                <PostSwitcher>
                    {/* <Link to={{
                        pathname: '/' + prevIndex,
                        state: {
                            nextIndex: postData.slug.current,
                            prevIndex: postData.slug.current,
                        }
                    }}>
                        &lt;
                    </Link> */}
                    <DateTitle>
                        {new Date(postData.publishedAt).toDateString()}
                    </DateTitle>
                    {/* <Link to={{
                        pathname: '/' + nextIndex,
                        state: {
                            index: nextIndex,
                        }
                    }}>
                        &gt;
                    </Link> */}
                </PostSwitcher>
            </Header>
            {postData.title ? <Title>{postData.title}</Title> : ''}
            {postData.author ? <Subtitle>{postData.author}</Subtitle> : ''}
            <VideoContainer>
                <TextContent>
                    <BlockContent
                        blocks={postData.body}
                        projectId={sanityClient.clientConfig.projectId}
                        dataset={sanityClient.clientConfig.dataset}
                    />
                </TextContent>
                <Overlay></Overlay>
                <ReactPlayer url={postData.videoUrl} controls={true} width="100%" height="auto" />
                {postData.mainImage ? <PostImage image={urlFor(postData.mainImage).width(414).url()}></PostImage> : ''}
            </VideoContainer>
        </PostContainer>
    );
}

export default Post;

const PostContainer = styled.div`
  margin: auto;
  width: 50%;

  @media (max-width: 425px) {
      width: 100vw;
  }
`;

const PostImage = styled.div`
    background: url(${props => props.image}) bottom left no-repeat;
    background-size: cover;
    width: 100%;
    height: 100vh;
`;

const TextContent = styled.div`
    font-family: 'Petit Formal Script', cursive;
    font-size: 20px;
    position: relative;
    top: 24px;
    text-align: left;
    margin: 0px 24px 0px 32px;
    z-index: 9998;
`;

const VideoContainer = styled.div`
    margin: auto;
    width: 50%;

  @media (max-width: 425px) {
      width: 100%;
  }
`;

const Header = styled.div`
    margin-top: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
    width: 100%;

    & img { 
        width: 24%; 
    }
    
`;

const PostSwitcher = styled.div`
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 85%;
    z-index: 9997;
    
    & a {
        font-family: 'Roboto Mono', monospace;
        text-decoration: none;
        font-size: 20px;
        color: #222;
    }
`;

const DateTitle = styled.h3`
    font-family: 'Roboto Mono', monospace;
    font-size: 16px;
    font-weight: 100;
    color: #444;
    width: 85%;
`;

const Overlay = styled.span`
    pointer-events: none;
    position: absolute;
    background-image: linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);
    width: 100%;
    height: 500px;
    z-index: 9997;
`;

const Title = styled.h2`
    position: relative;
    top: 60px;
    margin: auto;
    width: 88%;
    text-align: center;
    font-family: 'Petit Formal Script', cursive;
    font-weight: 100;
    font-size: 32px;
    color: #fff;
    z-index: 10000;
`;

const Subtitle = styled.h3`
    position: relative;
    top: 74px;
    margin: auto;
    width: 78%;
    text-align: center;
    font-family: 'Bebas Neue', sans-serif;
    color: #fff;
    z-index: 10000;
    letter-spacing: 1px;
    font-size: 20px;
`;